import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { WoodCrudService } from 'src/app/shared/services/wood-crud.service';
import { Wood } from 'src/app/shared/interfaces/wood';

@Component({
  selector: 'app-woods',
  templateUrl: './woods.component.html',
  styleUrls: ['./woods.component.scss']
})
export class WoodsComponent implements OnInit {

  woods: Wood[];
  wood: Wood;
  selectedWoods: Wood[] = [];

  woodDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private woodService : WoodCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Woods'}
    ];

    this.woods = [];
    this.wood = { } as Wood ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.woodService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.woods = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Wood = jsonItem as Wood;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.woods.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.woodService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.woods);
            doc.save('woods.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.woods);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "woods");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedWoods);
      // console.log('SAVEC CSV LOCATIONS ', this.woods);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedWoods, 'woods', exportCols);
   // this.exportService.exportToCsv(this.woods, 'woods', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.wood = {} as Wood;
    this.submitted = false;
    this.woodDialog = true;
  }

  deleteSelectedWoods() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected woods?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.woods = this.woods.filter(val => !this.selectedWoods.includes(val));
            this.selectedWoods = [];
            this.selectedWoods.forEach( wood => this.woodService.delete(wood.$key));
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Woodss Deleted', life: 3000});
        }
    });
  }

  editWood(wood: Wood) {
    this.wood = {...wood};
    this.woodDialog = true;
  }

  deleteWood(wood: Wood) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + wood.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.woods = this.woods.filter(val => val.$key !== wood.$key);
            this.wood = {} as Wood;
            this.woodService.delete(wood.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Wood Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.woodDialog = false;
    this.submitted = false;
  }

  saveWood() {
    this.submitted = true;

    if ( this.wood.name.trim() ) {
      if (this.wood.$key) {
          this.woods[this.findIndexById(this.wood.$key)] = this.wood;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Wood Updated', life: 3000});
          this.woodService.update(this.wood);
        } else {
          this.wood.position = this.woods.length;
          this.woodService.add(this.wood);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Wood Created', life: 3000});
      this.woods = [...this.woods];
    }

    this.woodDialog = false;
    this.wood = { } as Wood;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.woods.length; i++) {
        if (this.woods[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeWood(wood : Wood) {
    this.woodService.update(wood);
  }

  completePosition(wood : Wood) {
    if ( this.newPosition > -1 ) {
        wood.position = this.newPosition;
        wood = this.checkPositionLimits(wood);
        this.reorderElements(wood);
        //this.updateDB(wood);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.woods);
    // const myClonedArray = [];
    // this.woods.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.woods.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.woods.length - 1 - event.dropIndex;
    const woodToMove = this.woods[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.woods[index] = this.woods[index+1];
        this.woods[index].position = index;
        this.woodService.update(this.woods[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.woods[index] = this.woods[index-1];
        this.woods[index].position = index;
        this.woodService.update(this.woods[index]);
      }
    } 
    this.woods[endIndex] = woodToMove;
    this.woods[endIndex].position = endIndex;
    this.woodService.update(this.woods[endIndex]);
  }

  // onFieldEdit(wood: Spray, fieldName: string): void {
  //   //console.log(this.woods);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + wood[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       wood.position = this.newPosition;
  //       wood = this.checkPositionLimits(wood);
  //       this.reorderElements(wood);
  //       //this.updateDB(wood);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(wood);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.woods.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, wood: Wood) {
    // console.log("event" +event);
    if (wood.position != null && wood.position > -1) {
      this.previousPosition = wood.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(wood: Wood) {
    console.log('check ',wood.position + ' ' + this.woods.length);
    if (!wood.position) {
     // console.log('check 1');
      return this.wood;
    }
    if (wood.position < 0) {
      wood.position = 0;
      // console.log('check 2');
      return wood;
    }
    if (wood.position > this.woods.length) {
      wood.position = this.woods.length - 1;
    //  console.log('check 3', wood.position);
      return wood;
    }
   // console.log('check 4');
    return wood;
  }

  async reorderElements(wood: Wood) {
    this.newPosition = this.newPosition  > this.woods.length ? this.woods.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === wood.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const woodToMove = this.woods[startIndex];
   // console.log('Item to move: ', this.woods[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.woods);
        console.log('Item to +1: ', this.woods[index+1]);

        this.woods[index] = this.woods[index+1];
        this.woods[index].position = index;
        // console.log('Move: ', this.woods[index+1]);
        // console.log('Move pos: ', this.woods[index].position);
        //await this.updateDB(this.woods[index]);
        this.woodService.update(this.woods[index]);
     //   console.log('Update DB: ', this.woods[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.woods[index] = this.woods[index-1];
        this.woods[index].position = index;
        this.woodService.update(this.woods[index]);
      }
    } 
    this.woods[endIndex] = woodToMove;
    this.woods[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.woodService.update(this.woods[endIndex]);
    
    // const myClonedArray = [];
    // this.woods.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.woods = myClonedArray;
   // this.getAllRecords();
  }
}
